<div class="st-drawer-wrapper create-sale-order-line-drawer flex flex-column">
  <a href=""></a>

  <!-- Header -->
  <div class="st-drawer-header show-border flex flex-column" style="align-items: flex-start; gap: 12px;">
    <div class="flex-center-between w-100">
      <span class="text-header-18 text-semibold">{{ isEditMode ? 'Editar' : 'Añadir' }} Línea de pedido</span>
      <app-st-icon class="text-header-16 cursor-pointer" (click)="close()" [name]="'close'" [bold]="true">
      </app-st-icon>
    </div>
    <!-- Badges de información -->
    <div class="info-badges flex gap-100">
      <span class="st-badget subtle-grey">
        <label>Presupuesto: {{ nzData.saleOrder?.name || '-' }}</label>
      </span>
      <span class="st-badget subtle-grey">
        <label>Oportunidad: {{ nzData.saleOrder?.lead?.name || '-' }}</label>
      </span>
    </div>
  </div>

  <!-- Content -->
  <div class="st-drawer-content">

    <form [formGroup]="saleOrderLineForm" class="st-form" nz-form>
      <!-- Producto -->
      <div class="form-section">
        <span class="section-subtitle">Producto y Detalles</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Producto</nz-form-label>
                  <nz-form-control [nzErrorTip]="'El producto es requerido'">
                    <nz-select nzSize="large" formControlName="productId" nzPlaceHolder="Buscar producto..."
                      nzShowSearch>
                      <nz-option *ngFor="let product of productList" [nzValue]="product.id" [nzLabel]="product.name">
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Proveedor</nz-form-label>
                  <nz-form-control>
                    <app-avatar-select formControlName="supplierId" [options]="supplierList"
                      [createPartnerDrawerComponent]="ModifyPartnerDrawerComponent" [allowCreateNew]="true"
                      placeholder="Seleccione Proveedor" (partnerCreated)="onSupplierCreated($event)">
                    </app-avatar-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Descripci&oacute;n</nz-form-label>
                  <nz-form-control [nzErrorTip]="'La descripci&oacute;n es requerida'">
                    <textarea nzSize="large" nz-input formControlName="name" [nzAutosize]="{ minRows: 4, maxRows: 8 }"
                      placeholder="Introduce la descripci&oacute;n de la l&iacute;nea..."></textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Cantidad y unidad -->
      <div class="form-section">
        <span class="section-subtitle">Cantidad y unidad</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Cantidad</nz-form-label>
                  <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                    <input type="number" nzSize="large" nz-input formControlName="quantity" placeholder="0"
                      step="0.01" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Unidad</nz-form-label>
                  <nz-form-control>
                    <app-master-select formControlName="unitOfMeasureId" [options]="filteredUnitList"
                      placeholder="Seleccione Unidad" noneLabel="Ninguna" [noneValue]="0"
                      createPlaceholder="unidad..." [allowCreateNew]="true" masterType="unitOfMeasure"
                      [createDefaultValues]="{ unitOfMeasureCategoryId: getSelectedProductUnitCategoryId() }"
                      (createdItem)="onUnitOfMeasureCreated($event)">
                    </app-master-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Precio -->
      <div class="form-section">
        <span class="section-subtitle">Precio</span>

        <!-- Precio unitario -->
        <div nz-row [nzGutter]="16">
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Precio unitario</nz-form-label>
              <nz-form-control [nzErrorTip]="'El precio es requerido'">
                <input type="number" nzSize="large" nz-input formControlName="price" placeholder="0.00" step="0.01" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>Moneda</nz-form-label>
              <nz-form-control [nzErrorTip]="'La moneda es requerida'">
                <nz-select nzSize="large" formControlName="currencyId" nzPlaceHolder="Seleccione Moneda">
                  <nz-option *ngFor="let currency of currencies" [nzValue]="currency.id"
                    [nzLabel]="currency.isoCode || currency.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <!-- Descuento e Importe -->
        <div nz-row [nzGutter]="16">
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Descuento (%)</nz-form-label>
              <nz-form-control [nzErrorTip]="'El descuento debe estar entre 0 y 100'">
                <input type="number" nzSize="large" nz-input formControlName="discount" placeholder="0" min="0"
                  max="100" step="0.01" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Importe</nz-form-label>
              <nz-form-control>
                <div class="amount-display">
                  {{ saleOrderLineForm.get('amount')?.value | currency: getCurrencyCode() : 'symbol' : '1.2-2' }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <!-- Impuestos -->
      <div class="form-section">
        <span class="section-subtitle">Impuestos</span>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Impuestos</nz-form-label>
          <nz-form-control>
            <nz-select nzSize="large" formControlName="taxIds" [nzPlaceHolder]="saleOrderLineForm.value.productId && saleOrderLineForm.value.productId !== 0
                                ? 'Seleccione impuesto...'
                                : 'Seleccione un producto primero'"
              [nzDisabled]="!saleOrderLineForm.value.productId || saleOrderLineForm.value.productId === 0" nzShowSearch>
              <nz-option [nzValue]="null" nzLabel="Ninguno"></nz-option>
              <nz-option *ngFor="let tax of filteredTaxes" [nzValue]="tax.id"
                [nzLabel]="tax.name + ' (' + (tax.amount?.parsedValue || tax.amount || 0) + '%)'">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Localizaciones -->
      <div class="form-section">
        <span class="section-subtitle">Localizaciones</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Origen</nz-form-label>
                  <nz-form-control>
                    <app-master-select formControlName="sourceId" [options]="locationList"
                      placeholder="Seleccione origen" createPlaceholder="origen..."
                      [allowCreateNew]="true" masterType="location">
                    </app-master-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Destino</nz-form-label>
                  <nz-form-control>
                    <app-master-select formControlName="destinationId" [options]="locationList"
                      placeholder="Seleccione destino" createPlaceholder="destino..."
                      [allowCreateNew]="true" masterType="location">
                    </app-master-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

    </form>

    <!-- Subtotal (auto) -->
    <div class="subtotal-section">
      <div class="subtotal-display">
        <div class="subtotal-header">
          <span class="subtotal-label">Subtotal (auto)</span>
          <span class="subtotal-value">{{ saleOrderLineForm.get('amount')?.value | currency: getCurrencyCode() : 'symbol' : '1.2-2' }}</span>
        </div>
        <div class="subtotal-divider"></div>
        <div class="subtotal-details">
          <span class="subtotal-calculation">
            {{ saleOrderLineForm.get('quantity')?.value || 0 }} × {{ saleOrderLineForm.get('price')?.value || 0 | currency: getCurrencyCode() : 'symbol' : '1.2-2' }}
          </span>
          <span class="subtotal-discount">
            Desc. {{ saleOrderLineForm.get('discount')?.value || 0 | number: '1.0-0' }}%
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="st-drawer-footer show-border">
    <button nz-button class="text-btn-14" nzType="text" nzShape="round" nzSize="large" (click)="discard()">
      <span>Descartar</span>
    </button>
    <div class="flex-center gap-100">
      <button nz-button nzType="default" nzShape="round" nzSize="large" [disabled]="!saleOrderLineForm.valid"
        [nzLoading]="saving" (click)="saveAndNew()" *ngIf="!isEditMode">
        <span>Guardar y nuevo</span>
      </button>
      <button nz-button nzType="primary" nzShape="round" nzSize="large" [disabled]="!saleOrderLineForm.valid"
        [nzLoading]="saving" (click)="saveAndClose()">
        <span>Guardar y cerrar</span>
      </button>
    </div>
  </div>
</div>

<ng-template #notificationTmpl>
  <app-toast
    [notRef]="notRef!"
    [icon]="toastConfig.icon"
    [iconColor]="toastConfig.iconColor"
    [content]="toastConfig.content"
    [msg]="toastConfig.msg"
    [showUndo]="toastConfig.showUndo"
  ></app-toast>
</ng-template>
